import React from 'react'
import SigninContainer from '../../templates/signin/SigninContainer'

const SigninPage = props => <SigninContainer {...props} />

export default SigninPage



// WEBPACK FOOTER //
// ./src/components/pages/web/SigninPage.js